<template>
  <div style="padding: 20px">
    <div>
      <el-row :gutter="20" style="margin-bottom: 20px">
        <el-col :span="6" :offset="0" class="top-search">
          <span class="search-name">应用名称：</span>
          <el-input
            v-model="app_name"
            placeholder="请输入应用名称"
            size="normal"
          ></el-input>
        </el-col>
        <el-col :span="6" :offset="0" class="top-search">
          <span class="search-name">APPID：</span>
          <el-input
            v-model="appid"
            placeholder="请输入APPID"
            size="normal"
          ></el-input>
        </el-col>
        <el-col :span="6" :offset="0" class="top-search">
          <span class="search-name">订单编号：</span>
          <el-input
            v-model="payment_id"
            placeholder="请输入订单编号"
            size="normal"
          ></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-bottom: 20px">
        <el-col :span="8" :offset="0" class="top-search">
          <span class="search-name">支付日期(utc)：</span>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="timestamp"
          />
        </el-col>
        <el-col :span="3">
          <el-button type="primary" size="default" @click="searchData"
            >查询</el-button
          >
        </el-col>
        <el-col :span="3">
          <el-button type="info" size="default" @click="clear">清空</el-button>
        </el-col>
        <el-col :span="3">
          <el-button
            type="primary"
            size="default"
            @click="exportData"
            :loading="downloadLoading"
          >
            导出
          </el-button>
        </el-col>
      </el-row>
    </div>
    <el-table :data="list" border stripe>
      <el-table-column label="序号" prop="no"></el-table-column>
      <el-table-column label="应用名称" prop="app_name"></el-table-column>
      <el-table-column label="APPID" prop="appid"></el-table-column>
      <el-table-column label="TXID" prop="txid"></el-table-column>
      <el-table-column label="订单编号" prop="order_id"></el-table-column>
      <el-table-column label="商品名称" prop="product_name"></el-table-column>
      <el-table-column label="订单金额" prop="order_amount"></el-table-column>
      <el-table-column
        label="订单金额单位"
        prop="order_money_unit"
      ></el-table-column>
      <el-table-column
        label="支付的虚拟币"
        prop="cryptocurrency_amount"
      ></el-table-column>
      <el-table-column
        label="虚拟币类型"
        prop="cryptocurrency_unit"
      ></el-table-column>
      <el-table-column label="支付时间(utc)" prop="pay_time">
        <template slot-scope="scope">
          <div>{{ scope.row.pay_time }}</div>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getOrderList } from "@/api/developer.js";
import dayjs from "dayjs";
import { export_json_to_excel } from "@/utils/export2excel";
import { StartTime, EndTime, TimeStampFormat } from "@/utils/helper.js";

export default {
  components: {},
  data() {
    return {
      page: 1,
      pageSize: 20,
      list: [],
      total: 0,
      app_name: "",
      appid: "",
      payment_id: "",
      dateRange: [],
      export: [],
      downloadLoading: false,
    };
  },
  filters: {
    formatDate: function(value) {
      return dayjs(value * 1000).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const params = {
          page: this.page,
          page_size: this.pageSize,
          app_name: this.app_name,
          appid: this.appid,
          payment_id: this.payment_id,
          start_at: StartTime(this.dateRange[0]),
          end_at: EndTime(this.dateRange[1]),
        };
        // console.log(params);
        const { data } = await getOrderList(params);
        const { total = 0, items = [] } = data?.data;
        this.total = total;
        this.list = [...items];
      } catch (error) {
        console.log(error);
      }
    },
    async getExport() {
      try {
        const params = {
          page: 1,
          page_size: this.total,
          app_name: this.app_name,
          appid: this.appid,
          payment_id: this.payment_id,
          start_at: StartTime(this.dateRange[0]),
          end_at: EndTime(this.dateRange[1]),
        };
        const { data } = await getOrderList(params);
        const { total = 0, items = [] } = data?.data;
        this.export = [...items];
      } catch (error) {
        // console.log(error);
      }
    },
    searchData() {
      this.page = 1;
      this.fetchData();
    },
    clear() {
      this.appid = "";
      this.payment_id = "";
      this.app_name = "";
      this.dateRange = [];
      this.fetchData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.fetchData();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.fetchData();
    },
    exportData() {
      let header = [
        "序号",
        "应用名称",
        "APPID",
        "TXID",
        "订单编号",
        "商品名称",
        "订单金额",
        "订单金额单位",
        "支付的虚拟币",
        "虚拟币类型",
        "支付时间(utc)",
      ];
      this.downloadLoading = true;
      this.getExport().then(() => {
        let newData = [];
        let newDataItem = {};
        this.export.forEach((item, index) => {
          newDataItem = [
            item.no,
            item.app_name,
            item.appid,
            item.txid,
            item.order_id,
            item.product_name,
            item.order_amount,
            item.order_money_unit,
            item.cryptocurrency_amount,
            item.cryptocurrency_unit,
            item.pay_time,
          ];
          newData.push(newDataItem);
        });
        // console.log(header, newData);
        export_json_to_excel({
          header: header,
          data: newData, //具体数据 必填
          filename: `代收款订单流水${TimeStampFormat(
            this.dateRange[0]
          )}-${TimeStampFormat(this.dateRange[1])}`,
          autoWidth: true, //非必填
          bookType: "xlsx", //非必填
        });
        this.downloadLoading = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.top-search {
  display: flex;
  align-items: center;
  .search-name {
    word-break: keep-all;
    margin-right: 10px;
  }
}
</style>
